import React from 'react'; 
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox'; 
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { makeCsv, getTableDataForExport , getColKeyArrayObject} from 'state/actions/users';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import firebase from './../../../firebase';
import {Col} from 'react-bootstrap'; 

const Crm = () => {

  const [l, setL] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [colexport, setColExport] = React.useState([]);
  
  
  const fetchAndExportCsv = async (filename = 'crm-bo-house.csv') => {
    try {
      const separator = ';';
  
      // Récupération des données Firestore
      const snap = await firebase.firestore().collection('crm').get();
      let data = [];
  
      snap.forEach((doc) => {
        let row = doc.data();
        row.id = doc.id; // Ajout de l'ID Firestore
  
        // Suppression des colonnes inutiles
        const colsToRemove = ['RIB_file', 'RIB_text', 'preferences', 'settings', 'rib_file', 'mailingsList', 'owner_name',  'createdAt', 'created_At', '_updateAt', 'update_At', 'create_At'];
        colsToRemove.forEach((col) => delete row[col]);
  
        // Conversion des timestamps
        Object.keys(row).forEach((key) => {
          if (row[key] && row[key].seconds) {
            row[key] = new Date(row[key].seconds * 1000).toLocaleString();
          }
          if (key === 'birthday'){
            row[key] = new Date(row[key]).toLocaleDateString('fr-FR');
          }
        });
  
        // Extraction des objets imbriqués si nécessaire
        if (row.property && typeof row.property === 'object') {
          let p = "";
          row.property.forEach((prop) => {
            if (!p.includes(prop.label)) p += prop.label + ', ';
          })
          row.property = p
        }
        if (row.representBy && typeof row.representBy === 'object') {
          row.representBy = JSON.stringify(row.representBy);
        }
        if (row.lang && typeof row.lang === 'object') {
          row.lang = row.lang.value;
        }
      // Fusionner l'adresse complète en une seule colonne
        row.fullAddress = [
          row.adresse, 
          row.complement, 
          row.zipcode, 
          row.city, 
          row.country
        ].filter(Boolean).join(', ');

        // Supprimer les colonnes individuelles après la fusion
        delete row.adresse;
        delete row.city;
        delete row.zipcode;
        delete row.country;
        delete row.complement;


        // Fusionner l'adresse complète en une seule colonne
        row.AdresseBusiness = [
          row.businessAdresse,	row.businessCity, row.businessCountry, row.businessName, row.businessZipcode
        ].filter(Boolean).join(', ');

        delete row.businessAdresse;
        delete row.businessCity;
        delete row.businessCountry;
        delete row.businessName;
        delete row.businessZipcode;

        data.push(row);
      });
  
      if (data.length === 0) {
        console.warn('Aucune donnée trouvée.');
        return;
      }
  
      // Ordre des colonnes souhaité
      const orderedColumns = [
        'id','gender', 'firstName', 'lastName', 'email', 'phone','lang', "birthday", "nationality",'type','is_locataire', 'is_owner', 'property', 'representBy', 'fullAddress', "comment", "origin"
      ];
  
      // Ajouter les colonnes manquantes dynamiquement
      const keys = [...orderedColumns, ...Object.keys(data[0]).filter(k => !orderedColumns.includes(k))];
  
      // Génération du contenu CSV
      const csvContent = `${keys.join(separator)}\n${data
        .map((row) =>
          keys
            .map((k) => {
              let cell = row[k] === null || row[k] === undefined ? '' : row[k].toString().replace(/"/g, '""');
              if (cell.includes(';') || cell.includes('\n')) {
                cell = `"${cell}"`;
              }
              return cell;
            })
            .join(separator)
        )
        .join('\n')}`;
  
      // Création et téléchargement du fichier CSV
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, filename);
      console.log('CSV généré avec succès !');
  
    } catch (error) {
      console.error('Erreur lors de l\'export CSV:', error);
    }
  };
  const loadCrm = () => {
    firebase.firestore().collection('crm').get().then((snap)=> {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (l?.delete){

        }else{
          l.id = d.id;
          s.push(l) 
        }
      })
      setData(s);
      setColExport(getColKeyArrayObject(s));
    }).catch((error) => {
      setL(false); 
      var errorMessage = error.message;
      toast.error(errorMessage);
    })
  }
  const del = (id) => {
    if(confirm(`Êtes vous certain de vouloir supprimer le client?`)){
      delIt(id);
    }
  }
  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('crm').doc(id).update({delete:true}).then((snap)=> {
        
        toast.success("Suppression effectué");
        loadCrm();
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    } 
  };
  const columns = [
    {
      accessor: 'firstName',
      Header: 'Prénom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'lastName',
      Header: 'Nom',
      headerProps: { className: 'text-900' }
    },
    {
      accessor: 'email',
      Header: 'Email',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { emails, email } = rowData.row.original;
        if (emails?.length > 0){
            return(
              emails?.map((email) => { 
                return(
                  <p><a class="badge badge rounded-pill badge-subtle-warning" href={`mailto:${email}`}>{email}</a></p>
                )
                })
            )
        }else{
            if (email){
              return <p><a class="badge badge rounded-pill badge-subtle-warning" href={`mailto:${email}`}>{email}</a></p>
                
            }else{
              return(
                <p>Aucun email</p>
              )
            }
            
        }
        
      }
    },
    {
      accessor: 'type',
      Header: 'Type',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { type } = rowData.row.original;
        // personne moral ou physique
        return(<span >{type}​</span>) 
      }
    },
    {
      accessor: 'phone',
      Header: 'Téléphone',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { phone } = rowData.row.original; 
        if (phone?.length > 0){
          if (Array.isArray(phone)){
            return(<p>
              {phone?.map((ph) => { 
                return <><a class="badge badge rounded-pill badge-subtle-primary" href={`tel:${ph}`}>{ph}</a><br/></>
              })}
              </p>
            )
          }else{
            return (!Array.isArray(phone) && !phone.includes(',') ? (
              <p><a class="badge badge rounded-pill badge-subtle-primary" href={`tel:${phone}`}>{phone}</a></p>)
                
               : (<>{phone.split(',')?.map((ph) => { 
                return <><a class="badge badge rounded-pill badge-subtle-primary" href={`tel:${ph.trim()}`}>{ph.trim()}</a><br/></>
              })}</>))
          }
          
        }else{
          return(
            <p>Aucun téléphone</p>
          )
        }
      }
    },
    {
      accessor: 'is_owner',
      Header: 'Propriétaire',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { is_owner, owner_name,property } = rowData.row.original; 
 

        function removeDuplicates(array) {
          const uniqueValues = {};
          const result = [];
      
          array.forEach(item => {
              if (!uniqueValues[item.value]) {
                  uniqueValues[item.value] = true;
                  result.push(item);
              }
          });
      
          return result;
      }
 
        

        if (is_owner && property != undefined){ 
        const nproperty = removeDuplicates(property);
          return <p>
            {nproperty?.map((p, i)=>{
            return (
              <>
              {p?.label} 
              {nproperty[i+ 1] && (<br/>)}
              </>
            ) 
          })}
          </p> 
          
        }else{
          return(
            <p><span class="badge badge rounded-pill badge-subtle-secondary">x</span></p>
          )
        }
      }
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { email, id } = rowData.row.original
        return(<>
        
        <IconButton  href={`/crm/edit/${id}`}
          variant="falcon-default"
          size="sm"
          icon="edit"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1"></span>
        </IconButton> 
        
        
        <IconButton onClick={() => {
          del(id);
        }}
          variant="falcon-danger"
          size="sm"
          icon="trash"
          transform="shrink-3"
          className='me-2'
        >
          <span className="d-none d-sm-inline-block ms-1"></span>
        </IconButton> 
        </>
        )
      }
    }
  ];

  React.useEffect(() => {
    if (data.length === 0){
      loadCrm()
    }
  }, []);
 
 
 

function AdvanceTableExample() {

  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      pagination
      perPage={205}
    > 
      <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
      <div id="orders-actions">
      <IconButton  href="/newcrm"
        variant="falcon-default"
        size="sm"
        icon="plus"
        transform="shrink-3"
        className='me-2'
      >
        <span className="d-none d-sm-inline-block ms-1">Nouveau</span>
      </IconButton> 
      {data && data.length > 0 && (
              <IconButton 

                variant="falcon-default"
                size="sm"
                icon="file"
                transform="shrink-3"
                className='me-2'
                  onClick={() => {
                    // makeCsv(getTableDataForExport(data, colexport), `crm-bo-house.csv`)
                    fetchAndExportCsv()
                  }}
  
              >
                Export des données en CSV 
                  </IconButton>)}

      <Col xs="auto" sm={6} lg={4}>
          <AdvanceTableSearchBox table/>
        </Col>
    </div>
      </Col>
      <AdvanceTable
        table
        headerClassName="bg-200 text-nowrap align-middle"
        rowClassName="align-middle white-space-nowrap"
        tableProps={{
          bordered: true,
          striped: true,
          className: 'fs--1 mb-0 overflow-hidden'
        }}
      />
      <div className="mt-3">
        <AdvanceTableFooter
          rowCount={data.length}
          table
          rowInfo
          navButtons
          rowsPerPageSelection
        />
      </div>
    </AdvanceTableWrapper>
  );
} 


    return (
      
      <FalconComponentCard>
      <FalconComponentCard.Header
        title="Clients"
        light={false}
        className="border-bottom border-200" noPreview={true} 
      />
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
    );
}

export default Crm;
